module.exports = __webpack_public_path__ + "img/b.47a47d03.png";